// extracted by mini-css-extract-plugin
export default {"flexGap":"ReturnFrom_flexGap__okEx9","form-group":"ReturnFrom_form-group__GemAH"};